import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import jwtDecode from "jwt-decode";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    identity: undefined,
    accessToken: undefined,
    refreshToken: undefined,
  },
  mutations: {
    login(state, tokenResponse) {
      const tokenData = jwtDecode(tokenResponse.access_token);
      state.identity = {
        username: tokenData.user_name,
      };
      state.accessToken = tokenResponse.access_token;
      state.refreshToken = tokenResponse.refresh_token;
      console.log();
    },
    logout(state) {
      state.identity = undefined;
      state.accessToken = undefined;
      state.refreshToken = undefined;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      key: "gate-daemon-ui",
      paths: ["accessToken", "refreshToken", "identity"],
    }),
  ],
});
